import { Skeleton } from "antd";
import { TCertification } from "features/settings/types";
import React, { useState } from "react";
import { FileViewerModal } from "./FileViewerModal";
import { formatDate } from "admin/Authentication/hooks/useDateFormat";

export const Certifications: React.FC<{
  certifications: TCertification[];
  isLoading?: boolean;
}> = ({ certifications, isLoading }) => {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeFile, setActiveFile] = useState<string | null>(null);

    const getFileType = (url: string | null): "pdf" | "image" => {
      if (!url) return "image";
      const clean = url.split("?")[0].split("#")[0].toLowerCase();
      if (clean.endsWith(".pdf")) return "pdf";
      if (/\.(png|jpe?g|gif|webp|svg|bmp)$/.test(clean)) return "image";
      return "pdf";
    };

  if (!certifications.length) return null;

  return (
    <>
      <h3 className="font-semibold text-base text-gray-800 mb-4">
        Certifications
      </h3>

      <Skeleton active loading={isLoading}>
        <div className="space-y-4">
          {certifications.map((item: any) => (
            <div
              key={item.id}
              className="bg-white border border-gray-200 rounded-xl p-5"
            >
              <div className="space-y-1.5">
                <p className="text-sm text-gray-700">
                  <span className="font-semibold text-gray-800">Issuer:</span>{" "}
                  {item.issuer}
                </p>
                <p className="text-sm text-gray-700">
                  <span className="font-semibold text-gray-800">Title:</span>{" "}
                  {item.title}
                </p>
                {item.description && (
                  <p className="text-sm text-gray-700">
                    <span className="font-semibold text-gray-800">
                      Description:
                    </span>{" "}
                    {item.description}
                  </p>
                )}
                {item.issued_date && (
                  <p className="text-sm text-gray-700">
                    <span className="font-semibold text-gray-800">
                      Issued Date:
                    </span>{" "}
                    {formatDate(item.issued_date) || item.issued_date}
                  </p>
                )}
                {item.file_path && (
                  <div className="pt-2">
                    <button
                      type="button"
                      onClick={() => {
                        setActiveFile(item.file_path);
                        setViewerOpen(true);
                      }}
                      className="inline-flex items-center gap-1.5 bg-primary text-white text-sm font-medium px-4 py-2 rounded-md hover:bg-primary/90"
                    >
                      <i className="ri-eye-line"></i>
                      View Certificate
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Skeleton>

      <FileViewerModal
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        fileUrl={activeFile}
        fileType={getFileType(activeFile)}
      />
    </>
  );
};
